export default "__VITE_ASSET__lGGo4nzf__"